import { DEFAULT_RECOMMENDATIONS_ENDPOINT } from 'backend/lib/adapters/startPageAdapter';
import ContinuePlaying from 'components/ContinuePlaying/ContinuePlaying';
import IntroductionBanner from 'components/IntroductionBanner/IntroductionBanner';
import MyList from 'components/MyList/MyList';
import Recommendations from 'components/Recommendations/Recommendations';
import styles from './MyPage.module.css';
const MyPage = () => {
  return <>
      <IntroductionBanner title="Min sida" data-sentry-element="IntroductionBanner" data-sentry-source-file="MyPage.tsx">
        <p>
          Spara dina favoritprogram eller program du vill streama senare på Min
          sida.
        </p>
        <p>
          Dina sparade program under Min sida kan bara nås från den dator,
          surfplatta eller mobil där du sparade programmet.
        </p>
      </IntroductionBanner>
      <div className={styles.wrapper}>
        <ul>
          <li className={styles.blocks}>
            <MyList blockTracking={{
            blockIndex: 1,
            blockType: 'my_saved_programs',
            blockTitle: 'Min lista'
          }} title="Min lista" showRobotIfNoSavedProducts data-sentry-element="MyList" data-sentry-source-file="MyPage.tsx" />
          </li>
          <li className={styles.blocks}>
            <ContinuePlaying blockTracking={{
            blockIndex: 2,
            blockType: 'continue_playing',
            blockTitle: 'Fortsätt spela'
          }} data-sentry-element="ContinuePlaying" data-sentry-source-file="MyPage.tsx" />
          </li>
          <li className={styles.blocks}>
            <Recommendations title="Tips för dig" endpoint={DEFAULT_RECOMMENDATIONS_ENDPOINT} blockTracking={{
            blockIndex: 3,
            blockType: 'recommendations',
            blockTitle: 'Tips för dig'
          }} data-sentry-element="Recommendations" data-sentry-source-file="MyPage.tsx" />
          </li>
        </ul>
      </div>
    </>;
};
export default MyPage;